import React from "react";
import { Props } from "./types";
import styles from "./styles.scss";
import { DocumentCard } from "./documentCard";
import { Preview } from "@common/preview";
import { Identifiable, Document } from "@planzone/dto";

function ElementAttachments({ attachments, removeDocument }: Props) {
  const [selectedDocument, setSelectedDocument] =
    React.useState<Identifiable<Document> | null>(null);

  return (
    <div className={styles.elementAttachments}>
      <div>
        <ul className={styles.list}>
          {attachments.map((doc) => (
            <DocumentCard
              key={doc.uuid}
              document={doc}
              removeDocument={removeDocument}
              openPreview={(document) => {
                setSelectedDocument(document);
              }}
            />
          ))}
        </ul>
      </div>
      {selectedDocument && (
        <Preview
          document={selectedDocument}
          close={() => setSelectedDocument(null)}
        />
      )}
    </div>
  );
}

export { ElementAttachments };
